var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./SubmissionFormContributorsItem.jinja');
require('./SubmissionFormContributorsItem.less');


module.exports = Base.extend({

    template: template,

    events: {
        'click .SubmissionFormElement-delete': 'deleteItem',
        'click .SubmissionFormContributorsItem-invite': 'invite'
    },

    initialize: function (options) {
        this.options = options || {};

        var contributorID = this.$('input[name="id"]').val();

        if (app.settings.user == contributorID) {
            this.$('.SubmissionFormElement-delete').remove();
        }

        Base.prototype.initialize.call(this, options);
    },


    invite: function () {
        var email = this.$('.SubmissionFormContributorsItem-email').val();

        if (!app.utils.isValidEmail(email)) {
            this.$('.SubmissionFormContributorsItem-invite').flashClass('Button--shake', 500);

            return;
        }

        this.$el.addClass('SubmissionFormContributorsItem--filled');
        this.$el.removeClass('SubmissionFormContributorsItem--empty');

        this.trigger('invite');
    },


    deleteItem: function (e) {
        this.remove();

        this.trigger('delete');
    },


    getData: function () {
        var email = this.$('input[name="email"]').val();
        var data = {
            'email': this.$el.hasClass('SubmissionFormContributorsItem--filled') ? email : null
        };

        if (this.$('input[name="id"]').val()) {
            data.id = parseInt(this.$('input[name="id"]').val(), 10);
        }

        return data;
    }
});





//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormContributorsItem.js
// module id = 114
// module chunks = 0